import { useDebouncedDraft } from '@morph-mapper/node-inputs';
import { useCellEntryContext } from '../../context';

export const useEditCell = () => {
  /* Context State */
  const [currentColumn, setNewValue] = useCellEntryContext((s) => [
    s.getColumn(),
    s.setNewValue,
  ]);
  const [column, setColumn] = useDebouncedDraft<number | ''>(
    currentColumn ?? '',
    (nextColumn) => {
      if (nextColumn === '') return;
      setNewValue(nextColumn);
    },
  );

  return { column, setColumn };
};
